



















import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/header/MHeader.vue";
import EmailForm from "@/components/forms/EmailForm.vue";
import Footer from "@/components/Footer.vue";

@Component({
  components: {
    Header,
    EmailForm,
    Footer,
  },
})
export default class MResetPass extends Vue {}
